import { useEffect } from "react";
import { Typography, Box } from "@mui/material";
import MapOrders from "./MapOrders";
import "leaflet/dist/leaflet.css";
import { MapContainer, useMap } from "react-leaflet";
import useBreakpoints from "../../hooks/useBreakpoints";

export default function MapComponent(props) {
  const { isSmall } = useBreakpoints();

  function FlyMapTo() {
    const map = useMap();
    useEffect(() => {
      if (props.changeCenter && props.mapCenter) {
        map.flyTo([35.7009, 51.391241], 11);
        props.setChangeCenter(false);
      }
    }, [props.mapCenter, props.changeCenter]);
    return null;
  }

  return (
    <Box
      sx={{
        height: "100%",
        maxHeight: "89%",
      }}
    >
      <Box
        sx={{
          borderBottom: "1px solid #cdcdcd",
          display: "flex",
          alignItems: "center",
        }}
      >
        <Typography
          sx={{
            p: 1,
            px: 2,
            width: "100%",
            textAlign: "center",
          }}
          variant="subtitle1"
        >
          سفارشات
        </Typography>
      </Box>
      <MapContainer
        center={props.mapCenter}
        // center={center}
        zoom={11}
        style={{
          height: isSmall ? "20rem" : "100%",
          width: "100%",
        }}
      >
        <MapOrders
          changeZoom={props.changeZoom}
          setChangeZoom={props.setChangeZoom}
          locations={props.locations ? props.locations : ""}
          setAssignModel={props.setAssignModel}
          assignModel={props.assignModel}
          setOrderModel={props.setOrderModel}
          orderModel={props.orderModel}
        />
        <FlyMapTo />
      </MapContainer>
    </Box>
  );
}
